import Vue from "vue"
import VueRouter from "vue-router"
import Index from "../views/Index.vue"
import Mark from "../views/Mark.vue"
import Share from "../views/Share.vue"
import Huizhou from "../views/Huizhou.vue"
import Huizhoux from "../views/Huizhoux.vue"
import Dongguan from "../views/Dongguan.vue"
import Heyuan from "../views/Heyuan.vue"
import Shaoguan from "../views/Shaoguan.vue"
import Qingyuan from "../views/Qingyuan.vue"
import Yingde from "../views/Yingde.vue"


Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: { title: "MapShare - 探索" },
  },
  {
    path: "/mark",
    name: "Mark",
    component: Mark,
    meta: { title: "MapShare - 标记" },
  },
  {
    path: "/share",
    name: "share",
    component: Share,
    meta: { title: "MapShare - 共享" },
  },
  {
    path: "/hzx",
    name: "Huizhoux",
    component: Huizhoux,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/hz",
    name: "Huizhou",
    component: Huizhou,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/dg",
    name: "Dongguan",
    component: Dongguan,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/hy",
    name: "Heyuan",
    component: Heyuan,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/sg",
    name: "Shaoguan",
    component: Shaoguan,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/qy",
    name: "Qingyuan",
    component: Qingyuan,
    meta: { title: "MapShare - 进行中" },
  },
  {
    path: "/yd",
    name: "Yingde",
    component: Yingde,
    meta: { title: "MapShare - 进行中" },
  },
]

const router = new VueRouter({
  mode: "history",
  routes,
})

export default router
